export const PROFILE = "ADMIN/profile";
export const ACCOUNT_INFO = "AUTH/info";
export const ACCOUNT_PROFILE = "AUTH/profile";
export const ACCOUNT_INVOICE = "ACCOUNT/invoices";
export const ACCOUNT_PREPAID_BALANCE = "ACCOUNT/PREPAID/BALANCE";
export const ACCOUNT_POSTPAID_BALANCE = "ACCOUNT/POSTPAID/BALANCE";
export const ACCOUNT_FIXEDLINE_BALANCE = "ACCOUNT/FIXEDLINE/BALANCE";
